package io.github.kingsword09.symbolcraft.symbols.icons.`simple-icons`.icons

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import io.github.kingsword09.symbolcraft.symbols.icons.`simple-icons`.Icons

public val Icons.XSimpleIcons: ImageVector
    get() {
        if (_xSimpleIcons != null) {
            return _xSimpleIcons!!
        }
        _xSimpleIcons = Builder(name = "XSimpleIcons", defaultWidth = 24.0.dp, defaultHeight = 24.0.dp, viewportWidth = 24.0f, viewportHeight = 24.0f).apply {
            path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f, pathFillType = NonZero) {
                moveTo(14.23f, 10.16f)
                lineTo(22.98f, 0.0f)
                horizontalLineToRelative(-2.07f)
                lineToRelative(-7.59f, 8.82f)
                lineTo(7.25f, 0.0f)
                lineTo(0.26f, 0.0f)
                lineToRelative(9.17f, 13.34f)
                lineTo(0.26f, 24.0f)
                lineTo(2.33f, 24.0f)
                lineToRelative(8.02f, -9.32f)
                lineTo(16.75f, 24.0f)
                horizontalLineToRelative(6.99f)
                close()
                moveTo(11.40f, 13.46f)
                lineTo(10.47f, 12.13f)
                lineTo(3.08f, 1.56f)
                horizontalLineToRelative(3.18f)
                lineToRelative(5.97f, 8.53f)
                lineToRelative(0.93f, 1.33f)
                lineToRelative(7.75f, 11.09f)
                horizontalLineToRelative(-3.18f)
                close()
            }
        }
        .build()
        return _xSimpleIcons!!
    }

private var _xSimpleIcons: ImageVector? = null
